import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/privacy")({
  component: PrivacyRoute,
})

function PrivacyRoute() {
  return (
    <main className="min-h-[100dvh] bg-[#18191b] px-[24px] py-[72px] font-sans text-[#f1f7fe]">
      <article className="mx-auto max-w-[720px]">
        <a
          href="/login"
          className="text-[#7aa7ff] text-[14px]"
        >
          Back to login
        </a>
        <h1 className="mt-[32px] text-[36px] leading-[1.15]">Privacy Policy</h1>
        <p className="mt-[16px] text-[16px] text-[rgba(241,247,254,0.72)] leading-[1.7]">
          Playbrain CMS collects the account and session information needed to authenticate dashboard users,
          protect access, and record content-management activity.
        </p>
        <p className="mt-[16px] text-[16px] text-[rgba(241,247,254,0.72)] leading-[1.7]">
          Dashboard data is used for internal operations, security, auditing, and support. If you have
          questions about access or account data, ask a Playbrain administrator.
        </p>
      </article>
    </main>
  )
}
